import { render, staticRenderFns } from "./CheckAcesso.vue?vue&type=template&id=4c9bd2ab&"
import script from "./CheckAcesso.vue?vue&type=script&lang=js&"
export * from "./CheckAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports